import { render, staticRenderFns } from "./dingzhifromtradesman.vue?vue&type=template&id=1a0188b1&scoped=true&"
import script from "./dingzhifromtradesman.vue?vue&type=script&lang=js&"
export * from "./dingzhifromtradesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0188b1",
  null
  
)

export default component.exports